(function () {
  const input = document.querySelector('[data-pw-predictive-input]');
  const panel = document.querySelector('[data-pw-predictive-panel]');
  if (!input || !panel) return;

  let controller;
  let debouncer;

  function show(html) {
    panel.innerHTML = html;
    panel.hidden = !html.trim();
  }

  async function fetchResults(q) {
    if (controller) controller.abort();
    controller = new AbortController();

    const params = new URLSearchParams({
      q,
      'resources[type]': 'product,collection,article,page',
      'resources[limit]': '6',
      'section_id': 'predictive-search'
    });

    try {
      const res = await fetch(`/search/suggest?${params.toString()}`, {
        signal: controller.signal,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });

      if (!res.ok) return show('');

      const html = await res.text();
      const tmp = document.createElement('div');
      tmp.innerHTML = html;

      const dropdown = tmp.querySelector('.predictive-search-dropdown');
      if (dropdown && dropdown.innerHTML.trim()) {
        show(dropdown.outerHTML);
      } else {
        show('');
      }
    } catch (e) {
      if (e.name !== 'AbortError') show('');
    }
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearTimeout(debouncer);
    if (q.length < 2) { show(''); return; }
    debouncer = setTimeout(() => fetchResults(q), 180);
  });

  input.addEventListener('focus', () => {
    if (panel.innerHTML.trim()) panel.hidden = false;
  });

  document.addEventListener('click', (e) => {
    if (!panel.contains(e.target) && e.target !== input) panel.hidden = true;
  });
})();
